import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-114544e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav-icon"
}

import { ref, computed, toRefs } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'
import { NEllipsis } from 'naive-ui'
import usePreference from '@teams/common/hooks/usePreference'
import Icon from '@teams/common/components/icon'

// 下划线、矩形、胶囊
type Type = 'line' | 'card' | 'capsule'

interface CustomStyles {
  fillColor?: string
  activeTextColor?: string
  textColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'nav',
  props: {
    isDragging: { type: Boolean },
    icon: null,
    name: null,
    active: { type: Boolean },
    disabled: { type: Boolean },
    customStyles: { default: () => ({
      fillColor: 'var(--PC-nav-active-fill-color, var(--theme-team-01))',
      activeTextColor: 'var(--PC-nav-active-text-color, var(--text-01))',
      textColor: 'var(--PC-nav-default-text-color, var(--text-02))'
    }) },
    showArrow: { type: Boolean }
  },
  emits: ["update:visibility", "click:arrow"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visibility', visible: boolean): void
  (e: 'click:arrow', container: HTMLElement): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isDragging?: boolean, icon?: string, name?: string, active?: boolean, disabled?: boolean, customStyles: CustomStyles, showArrow?: boolean }

_useCssVars(_ctx => ({
  "106ff9d0": (_unref(navStyles).color),
  "0432d2ee": (_unref(navStyles).cursor),
  "9711d0b4": (_unref(navStyles).content),
  "47440f8d": (_unref(navStyles).fillColor),
  "90c42a90": (_unref(navStyles).boxShadow),
  "2496e58c": (_unref(navStyles).hoverColor)
}))





const { active, disabled, customStyles } = toRefs(props)

const preference = usePreference()

// 默认方型
const type = computed<Type>(
  () => (preference.current.theme.styles['PC-nav-style-type'] as any) ?? 'card'
)

const isUnderline = computed(() => type.value === 'line') // 下划线
const isRound = computed(() => type.value === 'capsule') // 胶囊
const isRectangle = computed(() => type.value === 'card') // 方型

const navRef = ref<HTMLElement | null>(null)

useIntersectionObserver(navRef, entries => {
  const [{ isIntersecting }] = entries
  emit('update:visibility', isIntersecting)
})

const navStyles = computed(() => ({
  cursor: disabled?.value ? undefined : 'pointer',
  color: active?.value
    ? customStyles.value?.activeTextColor
    : customStyles.value?.textColor,
  // https://forum.vuejs.org/t/css-v-bind-not-working-in-before-content-property/127801
  content: active?.value ? "''" : undefined,
  fillColor: active?.value ? customStyles.value.fillColor : undefined,
  boxShadow: active?.value ? 'var(--shadow-01)' : undefined,
  hoverColor: active?.value ? 'var(--theme-team-01)' : 'var(--theme-team-02)'
}))

function onArrowClick(e: MouseEvent) {
  e.stopPropagation()
  emit('click:arrow', navRef.value as HTMLElement)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'nav-container',
      {
        'nav-container__underline': _unref(isUnderline),
        'nav-container__round': _unref(isRound),
        'nav-container__rectangle': _unref(isRectangle)
      }
    ]),
    ref_key: "navRef",
    ref: navRef
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.icon), 1))
      : _createCommentVNode("", true),
    (__props.name)
      ? (_openBlock(), _createBlock(_unref(NEllipsis), {
          key: 1,
          class: "nav-name",
          tooltip: { placement: 'bottom', disabled: __props.isDragging }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.name), 1)
          ]),
          _: 1
        }, 8, ["tooltip"]))
      : _createCommentVNode("", true),
    (__props.showArrow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "nav-arrow__icon",
          onClick: onArrowClick
        }, [
          _createVNode(_unref(Icon), {
            name: "collapseArrow",
            size: 16,
            fill: "none"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})